import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { useId } from "react";
import { useTranslation } from "react-i18next";

interface AnswerRadioGroupProps {
  answer: number;
}

function AnswerRadioGroup({ answer }: AnswerRadioGroupProps) {
  const id = useId();
  const { t } = useTranslation();
  return (
    <RadioGroup
      className="inline-flex gap-12"
      value={answer.toString()}
      disabled={true}
    >
      <div className="inline-flex items-center gap-2">
        <RadioGroupItem value="1" id={`${id} 0`} />
        <label htmlFor={`${id} 0`}>{t("yes")}</label>
      </div>
      <div className="inline-flex items-center gap-2">
        <RadioGroupItem value="2" id={`${id} 1`} />
        <label htmlFor={`${id} 1`}>{t("no")}</label>
      </div>
      <div className="inline-flex items-center gap-2">
        <RadioGroupItem value="3" id={`${id} 2`} />
        <label htmlFor={`${id} 2`}>{t("not-applicable")}</label>
      </div>
    </RadioGroup>
  );
}

export default AnswerRadioGroup;
